/* eslint-disable no-console */
import {Flex} from 'antd';
import React from 'react';

// import BoxContent from '../../../../../components/BoxContent/BoxContent';
import ProgressChart from '../../../../../components/Chart/PieCharts/ProgressChart';
import CircleComp from '../../../../../components/DisplayComponent/CircleComp';
import MainTableTitle from '../../../../../components/Table/Utils/MainTableTitle';
// import ChartSwitch from '../../../../netZero/components/ChartSwitch';

const ChartWithDetails: React.FC<{
  mainData: any;
  noBackground?: boolean;
  showTitle?: boolean;
  tooltip?: string;
  labelType?: 'value' | 'percent';
  isValue?: boolean;
  customLabel?: string;
  showTotal?: boolean;
  customTotalTitle?: string;
  isCost?: boolean;
  mainLabel: string;
  subData: any[];
}> = ({
  // chartType = 'donut',
  // noBackground = false,
  showTitle = true,
  // dataInMainData = false,
  tooltip = '',
  customLabel = '',
  labelType,
  mainData = {},
  mainLabel,
  subData
}) => {
  return (
    // <BoxContent noBackground={noBackground}>
    <Flex className="ghgEmissionByScope" style={{gap: '1rem'}}>
      {showTitle && (
        <Flex className="titleFlex">
          <MainTableTitle
            title={mainLabel}
            showDivider={false}
            tooltip={tooltip}
          />
        </Flex>
      )}
      <ProgressChart
        data={subData?.toSorted((a) => {
          return a?.dataId === 'Filled' ? 1 : -1;
        })}
        mainData={mainData}
        customLabel={customLabel}
        labelType={labelType}
      />
      <Flex style={{width: '100%'}} justify="space-around">
        {subData?.map((item, index) => {
          return (
            <Flex key={index} align="center" gap={10}>
              <div>
                <CircleComp color={item?.fill} width={10} />
              </div>
              <div>{item?.label}</div>
            </Flex>
          );
        })}
      </Flex>
      {/* <Flex vertical={true}>
          {subData?.map((item: any, index: number) => {
            return (
              <Fragment key={index}>
                {labelType === 'line' ? (
                  <LineLegend
                    index={index}
                    item={item}
                    length={subData?.length}
                    isCost={isCost}
                  />
                ) : (
                  <FlexLegend index={index} item={item} isValue={isValue} />
                )}
              </Fragment>
            );
          })}
          <></>
        </Flex> */}
    </Flex>
    // </BoxContent>
  );
};

export default ChartWithDetails;
